<app-ds-menu-link
  [icon]="icon"
  [title]="text"
  [isStrong]="true"
  (clickEvent)="onClick()">
</app-ds-menu-link>